
<ion-button fill="clear" (click)="handleRapidClick()">{{ version }}</ion-button>
